var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegalDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 206,
    viewBox: "0 0 228 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.000976562 66.6039V0H227.273V66.6039H196.618V30.5945H30.6607V66.6039H-0.000976562Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M178.621 133.856H147.959V174.505H129.052V49.33H98.3906V174.505H78.9166V133.856H48.1953V205.092H98.3906H129.052H178.621V133.856Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8722 85.2052H0.0588379V115.785H78.8722V85.2052Z",
    fill: "#AA996D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M227.213 85.2052H148.399V115.785H227.213V85.2052Z",
    fill: "#AA996D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegalDark);
export default __webpack_public_path__ + "static/media/legal-dark.15623e7b88c865195f65d5061144e6bf.svg";
export { ForwardRef as ReactComponent };